export default [
  {
    path: '/admin/defines/catalog-statuses',
    name: 'CatalogStatuses',
    component: () => import('@/views/Admin/Defines/Catalog_statuses/Index.vue'),
    meta: {
      pageTitle: 'Katalog Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/catalog-statuses/add',
    name: 'CatalogStatusAdd',
    component: () => import('@/views/Admin/Defines/Catalog_statuses/Add.vue'),
    meta: {
      pageTitle: 'Görüşme Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/catalog-statuses',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/catalog-statuses/edit/:id',
    name: 'CatalogStatusEdit',
    component: () => import('@/views/Admin/Defines/Catalog_statuses/Edit.vue'),
    meta: {
      pageTitle: 'Görüşme Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/catalog-statuses',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
